<div class="app-checkbox">
  <span class="app-checkbox__input-wrapper" [ngClass]="{ noPaddingLeft: noPaddingLeft }">
    <input
      type="checkbox"
      [id]="inputId"
      class="app-checkbox__input"
      [formControl]="control"
      [ngClass]="{ _bigCheckbox: size === CHECK_BOX_SIZE.BIG }"
    />
  </span>

  <label
    [for]="inputId"
    class="app-checkbox__label"
    [ngClass]="{ _normal: fontSize === FONT_SIZE.NORMAL }"
    (click)="onLabelClick($event)"
  >
    <ng-container *ngIf="label; else labelTemplate">{{ label }}</ng-container>

    <ng-template #labelTemplate>
      <span><ng-content></ng-content></span>
    </ng-template>
  </label>
</div>
